/**
 * Created by Jan Bradac on 29.12.2015.
 *
 * Sources:
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
 * http://stackoverflow.com/questions/442404/retrieve-the-position-x-y-of-an-html-element
 * http://stackoverflow.com/questions/9956958/changing-the-position-of-bootstrap-popovers-based-on-the-popovers-x-position-in
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Tooltips;

    (function (Tooltips, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Tooltips, 'Enabler')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Object that allows the enabling of tooltips on page.
         *
         * @memberOf Lfl.Tooltips
         */
        Lfl.Tooltips.Enabler;

        (function (Enabler, $, undefined) {

            /*
             |===========================================================================================================
             | Object definition
             |===========================================================================================================
             */
            var MIN_VERTICAL_MARGIN = 150;
            // Linked to css .tooltip-inner in -shared.less
            var MIN_HORIZONTAL_MARGIN = 300;

            var selector = '[data-toggle="tooltip"]';

            var options = {
                placement: calculatePosition,

                //trigger: "click",

                delay: {"show": 200, "hide": 100}
            };


            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */

            /**
             * Sets the selector which will be used to find tooltips to enable.
             * @memberOf Lfl.Tooltips.Enabler
             */
            Enabler.setSelector = function (newSelector) {
                selector = newSelector;
            };

            /**
             * Sets the tooltips to be enabled when page fully loads.
             * @memberOf Lfl.Tooltips.Enabler
             */
            Enabler.enableOnPageLoad = function () {
                FunctionsCaller.register(function () {
                    Enabler.enableNow();
                })
            };

            /**
             * Enables all tooltips defined by currently set selector.
             * @memberOf Lfl.Tooltips.Enabler
             */
            Enabler.enableNow = function () {
                $(selector).tooltip(options)
            };


            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */

            /**
             * Checks if there is enough space on given side.
             * @param side
             * @param freeSpace
             */
            function isSideOk(side, freeSpace) {
                switch (side) {
                    case 'left':
                    case 'right':
                        return freeSpace[side] > MIN_HORIZONTAL_MARGIN;
                    case 'top':
                    case 'bottom':
                        return freeSpace[side] > MIN_VERTICAL_MARGIN;
                    default:
                        return false;
                }
            }

            function calculatePosition(context, source) {

                var rect = source.getBoundingClientRect();

                var $window = $(window);
                var viewportSize = {
                    width: $window.width(),
                    height: $window.height()
                };

                var preferredSides;

                if (typeof $(source).data('placement') === 'undefined') {
                    preferredSides = [];
                } else {
                    preferredSides = $(source).data('placement').split(' ');
                }


                /**
                 * Defines the ammount of free space around the element.
                 * @type {{top: Number, left: Number, bottom: Number, right: Number}}
                 */
                var freeSpace = {
                    top: rect.top,
                    left: rect.left,
                    bottom: viewportSize.height - rect.bottom,
                    right: viewportSize.width - rect.right
                };

                /*
                 |-------------------------------------------------------------------------
                 | First we check the user preferred sides in the order that they specified */

                var possiblePreferred =
                    _.find(preferredSides, function (side, key) {
                        return isSideOk(side, freeSpace);
                    });

                if (possiblePreferred !== undefined) {
                    return possiblePreferred;
                }

                /*
                 |-------------------------------------------------------------------------
                 | Then try to detect a side on which the tooltip would look better */

                // First we try horizontal placement
                if (freeSpace.left > freeSpace.right) {
                    if (isSideOk("left", freeSpace)) {
                        return "left";
                    }
                } else {
                    if (isSideOk("right", freeSpace)) {
                        return "right";
                    }
                }

                // Then vertical
                if (freeSpace.top > freeSpace.bottom) {
                    if (isSideOk("top", freeSpace)) {
                        return "top";
                    }
                } else {
                    if (isSideOk("bottom", freeSpace)) {
                        return "bottom";
                    }
                }

                // If all else fails, just put it on top.
                return "top";
            }

        }(Tooltips.Enabler = Tooltips.Enabler || {}, jQuery));
    }(Lfl.Tooltips = Lfl.Tooltips || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
